/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CustomFieldScope {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

export function CustomFieldScopeFromJSON(json: any): CustomFieldScope {
    return CustomFieldScopeFromJSONTyped(json, false);
}

export function CustomFieldScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldScope {
    return json as CustomFieldScope;
}

export function CustomFieldScopeToJSON(value?: CustomFieldScope | null): any {
    return value as any;
}

